// Module
var code = "<a name=nlgTableRemoveButton class=\"btn btn-xs red\" ng-click=removeElement()> <i class=\"fa fa-trash-o\"></i> </a>";
// Exports
module.exports = code;